// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"fab946ec","209":"3d882719","357":"402165eb","401":"a20f25dd","402":"cfcf4637","405":"55df10fe","496":"7de00b92","591":"d927310a","618":"9a7330a9","662":"f453c7e3","750":"20e87fa3","787":"9c8e9fd0","968":"88153919"}[chunkId] + ".chunk.js";
};